import { render } from "./SubSecondSecuritySettings.vue?vue&type=template&id=0953cdb0"
import script from "./SubSecondSecuritySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SubSecondSecuritySettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SubSecondStreaming/SubSecondSecuritySettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0953cdb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0953cdb0', __exports__)) {
    api.reload('0953cdb0', __exports__)
  }
  
  module.hot.accept("./SubSecondSecuritySettings.vue?vue&type=template&id=0953cdb0", () => {
    api.rerender('0953cdb0', render)
  })

}


export default __exports__